import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children"];
import styled from 'styled-components';
import { filterProps } from '../../utils';
import { useMapStylePropsToCSS } from '../../hooks/useMapStylePropsToCSS';
import { VIEW_RESET_STYLES } from './View.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledView = styled.div.withConfig({
  displayName: "View__StyledView",
  componentId: "ubuf56-0"
})(props => {
  const $cssStyles = props.$cssStyles;
  return Object.assign({}, VIEW_RESET_STYLES, $cssStyles);
});

/**
 * `View` is a primitive layout component that provides access to the
 * style props defined in the design system alongside many of our
 * token values.
 *
 * `View` does not handle flex or grid layouts. Use the `Flex` and `Grid`
 * components for those.
 */
export const View = _ref => {
  let {
      as = 'div',
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    styleProps
  } = filterProps(restProps);
  const cssStyles = useMapStylePropsToCSS(styleProps);
  return /*#__PURE__*/_jsx(StyledView, Object.assign({}, domProps, {
    as: as,
    $cssStyles: cssStyles,
    children: children
  }));
};